// extracted by mini-css-extract-plugin
export default {"expenseList":"Transctions_expenseList__JJaS3"};